import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import Colors from '../../../../ui/global/Colors';
import Fonts from '../../../../ui/global/Fonts';
import { GithubSyncStatus } from '../../../../backend/useGithubRepo';

const StatusContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 12px;
    font-family: ${Fonts.lexendSemiBold.fontFamily};
    font-weight: ${Fonts.lexendSemiBold.fontWeight};
`;

const SyncedDot = styled.div`
    width: 8px;
    height: 8px;
    background-color: ${Colors.green};
    border-radius: 50%;
`;

const ErrorDot = styled.div`
    width: 8px;
    height: 8px;
    background-color: ${Colors.red};
    border-radius: 50%;
`;

const Spinner = styled.div`
    border: 2px solid ${Colors.yellow};
    border-top: 2px solid transparent;
    border-radius: 50%;
    width: 8px;
    height: 8px;
    animation: spin 1s linear infinite;

    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
`;

interface SyncStatusProps {
    status: GithubSyncStatus;
}

const SyncStatus: FunctionComponent<SyncStatusProps> = ({ status }) => {
    switch (status) {
        case 'synced':
            return (
                <StatusContainer style={{ color: Colors.green }}>
                    <SyncedDot />
                    <span>SYNCED</span>
                </StatusContainer>
            );
        case 'error':
            return (
                <StatusContainer style={{ color: Colors.red }}>
                    <ErrorDot />
                    <span>ERROR</span>
                </StatusContainer>
            );
        case 'pending':
        case 'syncing':
        default:
            return (
                <StatusContainer style={{ color: Colors.yellow }}>
                    <Spinner />
                    <span>SYNCING</span>
                </StatusContainer>
            );
    }
};

export default SyncStatus;